export default "__VITE_ASSET__CyGZnWlB__"